import { cn } from '../../utils'
import {
    getBaseClasses,
    getColorClasses,
    getSizeClasses,
    getVariantClasses,
} from './Switcher.styles'
import { SwitcherProps } from './Switcher.types'

/*
 * @param name - Switcher name
 * @param variant - Default: "square" - "rounded" | "square"
 * @param color - Default: "primary" - "base" | "primary" | "gradient"
 * @param size - Default: "base" - "base" | "lg"
 * @param onChange - Watches for changes in input checkbox
 * @param className - If provided, adds classes to button
 * @param checked - Checked property for assigning the value
 * @param value - Value property of the checkbox
 * @param type - type is equal to "checkbox"
 * @param disabled - disabled property for disabling the button by default it is false
 */

export const Switcher = ({
    size,
    name,
    color,
    value,
    variant,
    checked,
    className,
    onChange,
    disabled = false,
}: SwitcherProps) => {
    const classes = cn(
        getVariantClasses(variant),
        getSizeClasses(size),
        getColorClasses(color),
        getBaseClasses()
    )
    return (
        <label className="relative inline-flex cursor-pointer items-center">
            <input
                type="checkbox"
                value={value}
                className="peer appearance-none"
                checked={checked}
                name={name}
                onChange={onChange}
                disabled={disabled}
            />
            <div className={cn(classes, className)}></div>
        </label>
    )
}
